module.exports = __webpack_public_path__ + "assets/menu-dish-image-loading-7416d4.svg";